'use client';

import * as React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  // Always render the button, but use default theme until mounted
  const isDark = mounted ? theme === 'dark' : false;

  return (
    <button
      onClick={() => {
        if (mounted) {
          setTheme(theme === 'dark' ? 'light' : 'dark');
        }
      }}
      className="relative inline-flex h-10 items-center gap-1 rounded-full border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-800"
      aria-label="Toggle theme"
    >
      {/* Track/Background */}
      <div className="relative flex items-center gap-1">
        {/* Sun Icon */}
        <div
          className={`flex h-8 w-8 items-center justify-center rounded-full transition-all duration-300 ${
            !isDark
              ? 'bg-yellow-400 text-white scale-100'
              : 'bg-transparent text-gray-400 dark:text-gray-600 scale-90'
          }`}
        >
          <Sun className="h-4 w-4" />
        </div>

        {/* Moon Icon */}
        <div
          className={`flex h-8 w-8 items-center justify-center rounded-full transition-all duration-300 ${
            isDark
              ? 'bg-indigo-600 text-white scale-100'
              : 'bg-transparent text-gray-400 scale-90'
          }`}
        >
          <Moon className="h-4 w-4" />
        </div>
      </div>
    </button>
  );
}

